<div class="title">
  {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DESCRIPTION_TITLE' | translate }}
</div>

<div
  class="full-width flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start"
>
  <div class="flex-[100%] gt-xs:max-w-[50%]">
    <div class="sub-title">
      {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DESCRIPTION_SUBTITLE' | translate }}
    </div>
  </div>
  <div class="input-wrapper">
    <form class="full-width flex-1" data-at-provide-description>
      <mat-form-field mat-input-height-large-label class="full-width">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DESCRIPTION_TITLE' | translate
        }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="description"
          gtmAction="Installation description"
          gtmCategory="gatewayCommissioningDescriptionForm"
          [gtmOn]="['change', 'focus', 'blur']"
          data-at-gateway-description-input
          matInput
          [formControl]="descriptionFormControl"
        />
        <mat-error
          *ngIf="descriptionFormControl?.errors?.required"
          data-at-description-error="required"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DESCRIPTION_ERROR_REQUIRED' | translate
          }}</mat-error
        >
        <mat-error
          *ngIf="descriptionFormControl?.errors?.minlength"
          data-at-description-error="minLength"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DESCRIPTION_ERROR_MIN_LENGTH' | translate
          }}</mat-error
        >
        <mat-error
          *ngIf="descriptionFormControl?.errors?.maxlength"
          data-at-description-error="maxLength"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DESCRIPTION_ERROR_MAX_LENGTH' | translate
          }}</mat-error
        >
      </mat-form-field>
    </form>
  </div>
</div>
